// extracted by mini-css-extract-plugin
module.exports = {"CoreValuesSection":"CoreValues_CoreValuesSection__RmPu7","CoreValues":"CoreValues_CoreValues__yaR2m","AboutBtn":"CoreValues_AboutBtn__xDY9v"};